import { render, staticRenderFns } from "./appInfo.vue?vue&type=template&id=1639c2f8"
import script from "./appInfo.vue?vue&type=script&lang=js"
export * from "./appInfo.vue?vue&type=script&lang=js"
import style0 from "./appInfo.vue?vue&type=style&index=0&id=1639c2f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports